var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.701274 0.229919C0.841899 0.0894684 1.03252 0.010579 1.23127 0.010579C1.43002 0.010579 1.62065 0.0894684 1.76127 0.229919L5.73127 4.19992L9.70127 0.229919C9.76994 0.156232 9.85274 0.0971299 9.94474 0.0561379C10.0367 0.015146 10.136 -0.00689556 10.2368 -0.00867234C10.3375 -0.0104491 10.4375 0.00807527 10.5309 0.0457963C10.6243 0.0835173 10.7091 0.139662 10.7803 0.210881C10.8515 0.282099 10.9077 0.366933 10.9454 0.460321C10.9831 0.553709 11.0016 0.653739 10.9999 0.754442C10.9981 0.855144 10.976 0.954458 10.9351 1.04646C10.8941 1.13846 10.835 1.22126 10.7613 1.28992L6.26127 5.78992C6.12065 5.93037 5.93002 6.00926 5.73127 6.00926C5.53252 6.00926 5.3419 5.93037 5.20127 5.78992L0.701274 1.28992C0.560823 1.14929 0.481934 0.95867 0.481934 0.759919C0.481934 0.561168 0.560823 0.370544 0.701274 0.229919Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnder);
export default __webpack_public_path__ + "static/media/under.7199e62f23877177c9bea2880da25528.svg";
export { ForwardRef as ReactComponent };